import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { Posting } from './posting.model';

export class PostingStateModel extends EntityStateModel<Posting> {}
